import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculator-vehicle-finance-tab.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorVehicleFinanceTab = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorVehicleFinanceTab, _super);
    function CalculatorVehicleFinanceTab(element) {
        return _super.call(this, element) || this;
    }
    CalculatorVehicleFinanceTab.prototype.init = function () {
        TooltipsService.initTooltips();
        this.form = this.element.querySelector('form');
        this.monthlyRepaymentElement = this.element.querySelector('.js-vaf-tab-monthly-repayment');
        this.financeAmountElement = this.element.querySelector('.js-vaf-tab-finance-amount');
        this.interestAmountElement = this.element.querySelector('.js-vaf-tab-interest-amount');
        this.balloonAmountElement = this.element.querySelector('.js-vaf-tab-balloon-amount');
        this.totalCostElement = this.element.querySelector('.js-vaf-tab-total-cost');
        this.clearInputsButton = this.element.querySelector('.js-calculator-clear-inputs');
        this.calculateButton = this.element.querySelector('.js-calculator-calculate');
        this.resultsElement = this.element.querySelector('.calculator-vehicle-finance-tab__results');
        this.interestRateInput = this.element.querySelector('[name="variable_interest_rate"]');
        this.interestRateDisplay = this.element.querySelector('.js-stepper-display');
        this.stepperMinusButton = this.element.querySelector('.js-stepper-minus');
        this.stepperPlusButton = this.element.querySelector('.js-stepper-plus');
        this.setDefaultValues();
        this.setupValidation();
        this.updateStepperDisplay();
        var rangeInput = this.form.querySelector('[name="term"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
        // Run an initial calculation so the results reflect the default values on load
        if (this.validateAllInputs()) {
            this.calculateVAF();
        }
    };
    CalculatorVehicleFinanceTab.prototype.bindEvents = function () {
        var _this = this;
        if (this.clearInputsButton) {
            this.clearInputsButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.resetForm();
            });
        }
        if (this.calculateButton) {
            this.calculateButton.addEventListener('click', function (e) {
                e.preventDefault();
                clearTimeout(_this.debounceTimer);
                if (_this.validateAllInputs()) {
                    _this.calculateVAF();
                    _this.showCalculationFeedback();
                }
            });
        }
        if (this.stepperPlusButton) {
            this.stepperPlusButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleStepperClick('up');
            });
        }
        if (this.stepperMinusButton) {
            this.stepperMinusButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleStepperClick('down');
            });
        }
        var rangeInput = this.form.querySelector('[name="term"]');
        if (rangeInput) {
            rangeInput.addEventListener('input', function () {
                _this.updateRangeDisplay(rangeInput);
                _this.triggerAutoCalculation();
            });
        }
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('name') !== 'term' && input.getAttribute('name') !== 'term_display') {
                    input.addEventListener('input', function () {
                        if (input.getAttribute('name') === 'variable_interest_rate') {
                            _this.updateStepperDisplay();
                        }
                        _this.triggerAutoCalculation();
                    });
                }
            });
        }
    };
    CalculatorVehicleFinanceTab.prototype.triggerAutoCalculation = function () {
        var _this = this;
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(function () {
            if (_this.validateAllInputs()) {
                _this.calculateVAF();
            }
        }, 300);
    };
    // Give the user clear visual feedback that the (re)calculation ran, since
    // the results often already reflect the latest inputs via auto-calculation.
    CalculatorVehicleFinanceTab.prototype.showCalculationFeedback = function () {
        if (this.calculateButton) {
            var button_1 = this.calculateButton;
            var originalText_1 = button_1.textContent;
            button_1.classList.add('is-calculating');
            button_1.disabled = true;
            button_1.textContent = 'Calculating...';
            setTimeout(function () {
                button_1.classList.remove('is-calculating');
                button_1.disabled = false;
                button_1.textContent = originalText_1;
            }, 600);
        }
        if (this.resultsElement) {
            this.resultsElement.classList.remove('is-updated');
            // Force reflow so the animation can be retriggered on repeated clicks.
            void this.resultsElement.offsetWidth;
            this.resultsElement.classList.add('is-updated');
            this.resultsElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };
    CalculatorVehicleFinanceTab.prototype.handleStepperClick = function (direction) {
        if (!this.interestRateInput)
            return;
        var currentValue = parseFloat(this.interestRateInput.value) || 0;
        var step = 0.25;
        if (direction === 'up') {
            currentValue = Math.min(27.25, currentValue + step);
        }
        else {
            currentValue = Math.max(1, currentValue - step);
        }
        currentValue = Math.round(currentValue * 100) / 100;
        this.interestRateInput.value = currentValue.toString();
        this.updateStepperDisplay();
        this.triggerAutoCalculation();
    };
    CalculatorVehicleFinanceTab.prototype.updateStepperDisplay = function () {
        if (!this.interestRateInput || !this.interestRateDisplay)
            return;
        var value = parseFloat(this.interestRateInput.value) || 0;
        this.interestRateDisplay.textContent = value + "%";
        if (this.stepperMinusButton) {
            if (value <= 1) {
                this.stepperMinusButton.classList.add('disabled');
                this.stepperMinusButton.setAttribute('aria-disabled', 'true');
            }
            else {
                this.stepperMinusButton.classList.remove('disabled');
                this.stepperMinusButton.removeAttribute('aria-disabled');
            }
        }
        if (this.stepperPlusButton) {
            if (value >= 27.25) {
                this.stepperPlusButton.classList.add('disabled');
                this.stepperPlusButton.setAttribute('aria-disabled', 'true');
            }
            else {
                this.stepperPlusButton.classList.remove('disabled');
                this.stepperPlusButton.removeAttribute('aria-disabled');
            }
        }
    };
    CalculatorVehicleFinanceTab.prototype.updateRangeDisplay = function (rangeInput) {
        var display = this.form.querySelector('[name="term_display"]');
        if (display) {
            display.value = rangeInput.value;
        }
    };
    CalculatorVehicleFinanceTab.prototype.calculateVAF = function () {
        var purchasePrice = parseFloat(this.getInputValue('purchase_price'));
        var deposit = parseFloat(this.getInputValue('deposit') || '0');
        var balloon = parseFloat(this.getInputValue('balloon') || '0');
        var term = parseFloat(this.getInputValue('term'));
        var interestRate = parseFloat(this.getInputValue('variable_interest_rate'));
        var result = this.financeCalculatorService.VAFCalculator(purchasePrice, deposit, balloon, 0, term, interestRate);
        if (this.monthlyRepaymentElement) {
            this.monthlyRepaymentElement.textContent = 'R ' + result.monthlyRepayment;
        }
        if (this.financeAmountElement) {
            this.financeAmountElement.textContent = typeof result.financeAmount === 'number'
                ? this.financeCalculatorService.formatter(result.financeAmount)
                : result.financeAmount;
        }
        if (this.interestAmountElement) {
            this.interestAmountElement.textContent = result.totalInterest;
        }
        if (this.balloonAmountElement) {
            this.balloonAmountElement.textContent = result.ballonAmount;
        }
        if (this.totalCostElement) {
            this.totalCostElement.textContent = result.loanAmount;
        }
    };
    CalculatorVehicleFinanceTab.prototype.getInputValue = function (name) {
        if (this.form) {
            var input = this.form.querySelector("[name=\"" + name + "\"]");
            if ((name === 'deposit' || name === 'balloon') && input && input.value === '') {
                return '0';
            }
            return input ? input.value || '0' : '0';
        }
        return '0';
    };
    CalculatorVehicleFinanceTab.prototype.setupValidation = function () {
        var _this = this;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                input.addEventListener('input', function () { return _this.validateInput(input); });
            });
        }
    };
    CalculatorVehicleFinanceTab.prototype.validateInput = function (input) {
        var name = input.getAttribute('name');
        if (name === 'term_display') {
            return true;
        }
        var value = parseFloat(input.value);
        var fieldContainer = input.closest('.calculator-vehicle-finance-tab__field');
        var validationMessage = fieldContainer ? fieldContainer.querySelector('.validation-message') : null;
        var showError = function (message) {
            if (validationMessage) {
                validationMessage.textContent = message;
                validationMessage.style.display = 'block';
                input.classList.add('is-invalid');
            }
            return false;
        };
        var clearError = function () {
            if (validationMessage) {
                validationMessage.style.display = 'none';
                input.classList.remove('is-invalid');
            }
            return true;
        };
        switch (name) {
            case 'purchase_price':
                if (input.value.trim() === '' || isNaN(value)) {
                    return showError('Purchase price is required');
                }
                if (value < 100000 || value > 10000000) {
                    return showError('Enter an amount between 100 000 and 10 000 000');
                }
                break;
            case 'deposit': {
                if (input.value.trim() === '') {
                    return clearError();
                }
                if (isNaN(value) || value < 0) {
                    return showError('Enter a valid deposit amount');
                }
                var purchasePriceInput = this.form.querySelector('[name="purchase_price"]');
                var purchasePrice = purchasePriceInput ? parseFloat(purchasePriceInput.value) : NaN;
                if (!isNaN(purchasePrice) && value > purchasePrice) {
                    return showError('Deposit cannot be more than the purchase price');
                }
                break;
            }
            case 'balloon':
                if (input.value.trim() === '') {
                    return clearError();
                }
                if (isNaN(value) || value < 0 || value > 35) {
                    return showError('Enter a balloon percentage between 0 and 35');
                }
                break;
            case 'variable_interest_rate':
                if (input.value.trim() === '' || isNaN(value)) {
                    return showError('Interest rate is required');
                }
                if (value < 1 || value > 27.25) {
                    return showError('Enter an interest rate between 1 and 27.25');
                }
                break;
            case 'term':
                if (isNaN(value) || value < 12 || value > 72) {
                    return showError('Value must be between 12 and 72 months');
                }
                break;
        }
        return clearError();
    };
    CalculatorVehicleFinanceTab.prototype.validateAllInputs = function () {
        var _this = this;
        var isValid = true;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('name') !== 'term_display') {
                    if (!_this.validateInput(input)) {
                        isValid = false;
                    }
                }
            });
        }
        return isValid;
    };
    CalculatorVehicleFinanceTab.prototype.setDefaultValues = function () {
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                var defaultValue = input.getAttribute('data-value');
                if (defaultValue !== null) {
                    input.value = defaultValue;
                }
            });
        }
    };
    CalculatorVehicleFinanceTab.prototype.resetForm = function () {
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                var defaultValue = input.getAttribute('data-value');
                if (defaultValue !== null) {
                    input.value = defaultValue;
                }
                input.classList.remove('is-invalid');
            });
            var validationMessages = this.form.querySelectorAll('.validation-message');
            validationMessages.forEach(function (message) {
                message.style.display = 'none';
                message.textContent = '';
            });
        }
        if (this.monthlyRepaymentElement) {
            this.monthlyRepaymentElement.textContent = 'R 0.00';
        }
        if (this.financeAmountElement) {
            this.financeAmountElement.textContent = '0.00';
        }
        if (this.interestAmountElement) {
            this.interestAmountElement.textContent = '0.00';
        }
        if (this.balloonAmountElement) {
            this.balloonAmountElement.textContent = '0.00';
        }
        if (this.totalCostElement) {
            this.totalCostElement.textContent = '0.00';
        }
        this.updateStepperDisplay();
        var rangeInput = this.form.querySelector('[name="term"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
    };
    return CalculatorVehicleFinanceTab;
}(Base));
export { CalculatorVehicleFinanceTab };



//////////////////
// WEBPACK FOOTER
// ./components/calculator-vehicle-finance-tab/calculator-vehicle-finance-tab.component.ts
// module id = 1133
// module chunks = 0